import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IChangeHistoryEntry } from '@modules/change-history/components/VChangeHistory/types';
import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { PLAYERS_PERMISSIONS } from '@modules/players/constants';
import {
  PLAYER_PROFILE_TRACKING_API_URL,
  PLAYER_TRACKING_HISTORY_QUERY_KEY,
} from '@modules/players/submodules/PlayerProfile/constants';

export default function usePlayerTrackingHistoriesQuery(playerId: Ref<string>, merchant: Ref<number>):
IContextQueryResult<IChangeHistoryEntry[], Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [PLAYER_TRACKING_HISTORY_QUERY_KEY, playerId],
    queryFn: () => fetchGet<IChangeHistoryEntry[]>(
      PLAYER_PROFILE_TRACKING_API_URL,
      {
        permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
        urlParams: {
          playerId: playerId.value,
        },
        queryParams: {
          merchant: merchant.value,
        },
      },
    ),
    enabled: computed(() => !!playerId.value),
  });
}
